import Swiper from "swiper/bundle";
import "swiper/css/bundle";

(() => {
  const Moonbase = window.Moonbase || {};
  const swipers = document.querySelectorAll(".swiper");
  const defaultSettings = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
  };

  Moonbase.Swiper = Swiper;

  swipers.forEach((swiper) => {
    let settings = JSON.parse(swiper.dataset.swiper || "{}");

    new Swiper(swiper, {
      ...defaultSettings,
      ...settings,

      on: {
        init: function () {
          const aside = swiper.closest("aside");
          const section = swiper.closest("section");
          if (section) {
            let pauseButton = section.querySelector(".swiper-button-pause");

            if (pauseButton) {
              pauseButton.addEventListener("click", () => {
                if (swiper.swiper.autoplay.running) {
                  swiper.swiper.autoplay.stop();
                  pauseButton.classList.add("swiper-button-pause--active");
                  pauseButton
                    .querySelector(".js-pause-icon")
                    .classList.add("hidden");
                  pauseButton
                    .querySelector(".js-play-icon")
                    .classList.remove("hidden");
                } else {
                  swiper.swiper.autoplay.start();
                  pauseButton.classList.remove("swiper-button-pause--active");
                  pauseButton
                    .querySelector(".js-pause-icon")
                    .classList.remove("hidden");
                  pauseButton
                    .querySelector(".js-play-icon")
                    .classList.add("hidden");
                }
              });
            }

            swiper.addEventListener("focusin", () => {
              if (swiper.swiper.autoplay.running) {
                swiper.swiper.autoplay.stop();
                if (pauseButton) {
                  pauseButton.classList.add("swiper-button-pause--active");
                  pauseButton
                    .querySelector(".js-pause-icon")
                    .classList.add("hidden");
                  pauseButton
                    .querySelector(".js-play-icon")
                    .classList.remove("hidden");
                }
              }
            });
          }

          if (aside) {
            let pauseButton = aside.querySelector(".swiper-button-pause");

            if (pauseButton) {
              pauseButton.addEventListener("click", () => {
                if (swiper.swiper.autoplay.running) {
                  swiper.swiper.autoplay.stop();
                  pauseButton.classList.add("swiper-button-pause--active");
                  pauseButton
                    .querySelector(".js-pause-icon")
                    .classList.add("hidden");
                  pauseButton
                    .querySelector(".js-play-icon")
                    .classList.remove("hidden");
                } else {
                  swiper.swiper.autoplay.start();
                  pauseButton.classList.remove("swiper-button-pause--active");
                  pauseButton
                    .querySelector(".js-pause-icon")
                    .classList.remove("hidden");
                  pauseButton
                    .querySelector(".js-play-icon")
                    .classList.add("hidden");
                }
              });
            }

            swiper.addEventListener("focusin", () => {
              if (swiper.swiper.autoplay.running) {
                swiper.swiper.autoplay.stop();
                if (pauseButton) {
                  pauseButton.classList.add("swiper-button-pause--active");
                  pauseButton
                    .querySelector(".js-pause-icon")
                    .classList.add("hidden");
                  pauseButton
                    .querySelector(".js-play-icon")
                    .classList.remove("hidden");
                }
              }
            });
          }
        },
      },
    });
  });

  window.Moonbase.initSwiper = (swiper) => {
    let settings = JSON.parse(swiper.dataset.swiper || "{}");
    new Swiper(swiper, {
      ...defaultSettings,
      ...settings,
    });
  };

  const pdpGallery = document.querySelector(".product-main__gallery");
  const pdpGalleryThumbs = document.querySelector(
    ".product-thumbnails__gallery"
  );

  const thumbsSettings = {
    direction: "horizontal",
    slidesPerView: 10,
    spaceBetween: 8,
    watchSlidesProgress: true,
    freeMode: true,
    breakpoints: {
      1024: {
        spaceBetween: 12,
        direction: "vertical",
      },
    },
  };
  let thumbnailSwiper;
  if (pdpGalleryThumbs) {
    thumbnailSwiper = new Swiper(pdpGalleryThumbs, {
      ...defaultSettings,
      ...thumbsSettings,
    });
  }

  const gallerySettings = {
    loop: true,
    slidesPerView: 1.25,
    navigation: {
      nextEl: ".swiper-button-next--pdp-gallery",
      prevEl: ".swiper-button-prev--pdp-gallery",
    },
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination--pdp-gallery",
      type: "bullets",
    },
    scrollbar: {
      el: ".swiper-scrollbar--pdp-gallery",
      draggable: true,
    },
    thumbs: {
      swiper: thumbnailSwiper,
    },
    breakpoints: {
      1024: {
        slidesPerView: 1,
      },
    },
  };

  let pdpGallerySwiper;
  if (pdpGallery) {
    pdpGallerySwiper = new Swiper(pdpGallery, {
      ...defaultSettings,
      ...gallerySettings,
    });
  }
})();

let WPTswiper = new Swiper(".swiper--wpt-finder", {
  slidesPerView: 1,
  loop: false,
  allowTouchMove: false,
  touchRatio: 0,
  autoHeight: true,
  a11y: {
    enabled: true,
  },
  spaceBetween: 0,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  keyboard: {
    enabled: false,
  },
  on: {
    init: function () {
      const slides = this.slides;
      slides.forEach((slide) => {
        slide.setAttribute("tabIndex", "-1");
      });
      this.slides[this.activeIndex].setAttribute("tabIndex", "0");
    },
    slideChange: function () {
      const slides = this.slides;
      slides.forEach((slide) => {
        slide.setAttribute("tabIndex", "-1");
      });
      this.slides[this.activeIndex].setAttribute("tabIndex", "0");
    },
  },
});

// const swiperAnswerLinks = document.querySelectorAll(".js-swiper-answer-link");
// const swiperSlides = document.querySelectorAll(
//   ".swiper--wpt-finder .swiper-slide"
// );

// swiperAnswerLinks.forEach((answerLink) => {
//   let slideId = answerLink.getAttribute("data-slide-link-id");
//   console.log("slideId", slideId);

//   answerLink.addEventListener("click", (event) => {
//     event.preventDefault();
//     console.log("clicked", slideId);
//     const targetSlide = document.querySelector(`#wpt_slider_${slideId}`);
//     if (targetSlide) {
//       const index = Array.from(swiperSlides).indexOf(targetSlide);
//       console.log("index", index);
//       WPTswiper.slideTo(index, 500, true);
//     }
//   });
// });
